import React from 'react';
import { useForm } from 'react-hook-form';
import { FaSchool, FaTruck } from 'react-icons/fa';

const BusinessInfoTab = ({
  businessName,
  setBusinessName,
  businessAddress,
  setBusinessAddress,
  postCode,
  setPostCode,
  venues,
  setVenues,
  fullName,
  contactEmail,
  contactPhone,
  onSave,
  onPrev,
  onNext
}) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      businessName,
      businessAddress,
      postCode
    }
  });

  const handleAddVenue = () => {
    setVenues([...venues, {
      deliveryOption: 'pickup',
      collectorName: '',
      collectorEmail: '',
      collectorPhone: '',
      address: '',
      postCode: '',
      instructions: '',
      useMainContact: false,
      contactName: '',
      venueContactEmail: '',
      venueContactPhone: ''
    }]);
  };

  const handleRemoveVenue = (index) => {
    const newVenues = [...venues];
    newVenues.splice(index, 1);
    setVenues(newVenues);
  };

  const handleChangeVenue = (index, field, value) => {
    const newVenues = [...venues];
    newVenues[index][field] = value;
    setVenues(newVenues);
  };

  const handleUseMainContactChange = (index, useMainContact) => {
    const updatedVenues = [...venues];
    updatedVenues[index] = {
      ...updatedVenues[index],
      useMainContact,
      contactName: useMainContact ? fullName : updatedVenues[index].contactName,
      venueContactEmail: useMainContact ? contactEmail : updatedVenues[index].venueContactEmail,
      venueContactPhone: useMainContact ? contactPhone : updatedVenues[index].venueContactPhone
    };
    setVenues(updatedVenues);
  };

  return (
    <div className="tab-content">
      <h1>Club/School Information</h1>
      <form onSubmit={handleSubmit(onSave)} className="business-form">
        <div className="form-group">
          <label htmlFor="businessName">School/Club Name</label>
          <input
            type="text"
            id="businessName"
            value={businessName}
            {...register("businessName", {
              required: "School/Club Name is required",
              onChange: (e) => setBusinessName(e.target.value)
            })}
          />
          {errors.businessName && <span className="error-text">{errors.businessName.message}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="businessAddress">Address</label>
          <input
            type="text"
            id="businessAddress"
            value={businessAddress}
            {...register("businessAddress", {
              required: "Address is required",
              onChange: (e) => setBusinessAddress(e.target.value)
            })}
          />
          {errors.businessAddress && <span className="error-text">{errors.businessAddress.message}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="postCode">Post Code</label>
          <input
            type="text"
            id="postCode"
            value={postCode}
            {...register("postCode", {
              required: "Post Code is required",
              onChange: (e) => setPostCode(e.target.value)
            })}
          />
          {errors.postCode && <span className="error-text">{errors.postCode.message}</span>}
        </div>
        <div className="venues-section grid-full-width">
          <h3>Venues</h3>
          {venues.map((venue, index) => (
            <div key={index} className="venue-card">
              <div className="venue-header">
                {venue.deliveryOption === 'pickup' ? <FaSchool className="venue-icon" /> : <FaTruck className="venue-icon" />}
                <span>Venue #{index + 1} ({venue.deliveryOption})</span>
                <button type="button" className="remove-btn" onClick={() => handleRemoveVenue(index)}>Remove</button>
              </div>
              <div className="form-group">
                <label>Logistics Option</label>
                <select
                  value={venue.deliveryOption}
                  onChange={(e) => handleChangeVenue(index, 'deliveryOption', e.target.value)}
                  required
                >
                  <option value="pickup">Pickup</option>
                  <option value="delivery">Delivery</option>
                </select>
              </div>
              <div className="form-group">
                <label>Venue Address</label>
                <input
                  type="text"
                  value={venue.address}
                  onChange={(e) => handleChangeVenue(index, 'address', e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>Post Code</label>
                <input
                  type="text"
                  value={venue.postCode}
                  onChange={(e) => handleChangeVenue(index, 'postCode', e.target.value)}
                  required
                />
              </div>
              {venue.deliveryOption === 'delivery' && (
                <>
                  <div className="form-group">
                    <label>Delivery Instructions</label>
                    <input
                      type="text"
                      value={venue.instructions}
                      onChange={(e) => handleChangeVenue(index, 'instructions', e.target.value)}
                    />
                  </div>
                  <div className="form-group checkbox-group">
                    <input
                      type="checkbox"
                      checked={venue.useMainContact}
                      onChange={(e) => handleUseMainContactChange(index, e.target.checked)}
                    />
                    <label>Use Main Contact Details</label>
                  </div>
                  {!venue.useMainContact && (
                    <>
                      <div className="form-group">
                        <label>Contact Name</label>
                        <input
                          type="text"
                          value={venue.contactName}
                          onChange={(e) => handleChangeVenue(index, 'contactName', e.target.value)}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Contact Email</label>
                        <input
                          type="email"
                          value={venue.venueContactEmail}
                          onChange={(e) => handleChangeVenue(index, 'venueContactEmail', e.target.value)}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Contact Phone</label>
                        <input
                          type="tel"
                          value={venue.venueContactPhone}
                          onChange={(e) => handleChangeVenue(index, 'venueContactPhone', e.target.value)}
                          required
                        />
                      </div>
                    </>
                  )}
                </>
              )}
              {venue.deliveryOption === 'pickup' && (
                <>
                  <div className="form-group">
                    <label>Pickup Person's Name</label>
                    <input
                      type="text"
                      value={venue.contactName}
                      onChange={(e) => handleChangeVenue(index, 'contactName', e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Pickup Person Email</label>
                    <input
                      type="email"
                      value={venue.venueContactEmail}
                      onChange={(e) => handleChangeVenue(index, 'venueContactEmail', e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Pickup Person Phone</label>
                    <input
                      type="tel"
                      value={venue.venueContactPhone}
                      onChange={(e) => handleChangeVenue(index, 'venueContactPhone', e.target.value)}
                      required
                    />
                  </div>
                </>
              )}
            </div>
          ))}
          <button type="button" className="add-venue-btn" onClick={handleAddVenue}>Add Venue</button>
        </div>
        <div className="form-navigation grid-full-width">
          <button type="button" onClick={onPrev}>Previous</button>
          <button type="submit">Save Changes</button>
          <button type="button" onClick={onNext}>Next</button>
        </div>
      </form>
    </div>
  );
};

export default BusinessInfoTab;
